export default {
  setPlantList (state: any, payload: any) {
    state.plantData = payload
  },
  setSelectedYear (state: {[key:string]: number}, value: number) {
    state.selectedYear = value
  },
  setSelectedSeason (state: {[key:string]: number}, value: number) {
    state.selectedSeason = value
  },
  setIsAllPlantings (state: {[key:string]: boolean}, value: boolean) {
    state.isAllPlantings = value
  },
  setSearchText (state: {[key:string]: string}, payload: string) {
    state.searchText = payload
  },
  setCurrentPage (state: {[key:string]: number}, page: number) {
    state.currentPage = page
  },
  setOrderName (state: {[key:string]: string}, name: string) {
    state.orderName = name
  },
  setSortAsc (state: {[key:string]: boolean}, sort: boolean) {
    state.sortAsc = sort
  },
  setFieldSearchText (state: {[key:string]: string}, payload: string) {
    state.fieldSearchText = payload
  },
  setFieldCurrentPage (state: {[key:string]: number}, page: number) {
    state.fieldCurrentPage = page
  },
  setFieldOrderName (state: {[key:string]: string}, name: string) {
    state.fieldOrderName = name
  },
  setFieldSortAsc (state: {[key:string]: boolean}, sort: boolean) {
    state.fieldSortAsc = sort
  }
}
